import { render, staticRenderFns } from "./MenuComp.vue?vue&type=template&id=322ba7db&"
import script from "./MenuComp.vue?vue&type=script&lang=js&"
export * from "./MenuComp.vue?vue&type=script&lang=js&"
import style0 from "./MenuComp.vue?vue&type=style&index=0&id=322ba7db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports